import React from 'react';
import { string } from 'prop-types';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import classNames from 'classnames';
import { twitterPageURL } from '../../util/urlHelpers';
import config from '../../config';
import {
  IconSocialMediaFacebook,
  IconSocialMediaInstagram,
  IconSocialMediaTwitter,
  Logo,
  ExternalLink,
  NamedLink,
} from '../../components';
// import {ReactComponent as Logo1} from "../../assets/svg/SosLogo.svg"
import footerlogo from '../../assets/DjobLogo_Reverse.png';

import css from './Footer.module.css';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import { compose } from 'redux';
import { connect } from 'react-redux';

const renderSocialMediaLinks = intl => {
  const { siteFacebookPage, siteInstagramPage, siteTwitterHandle } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  const goToFb = intl.formatMessage({ id: 'Footer.goToFacebook' });
  const goToInsta = intl.formatMessage({ id: 'Footer.goToInstagram' });
  const goToTwitter = intl.formatMessage({ id: 'Footer.goToTwitter' });

  const fbLink = siteFacebookPage ? (
    <ExternalLink key="linkToFacebook" href={siteFacebookPage} className={css.icon} title={goToFb}>
      <IconSocialMediaFacebook />
    </ExternalLink>
  ) : null;

  const twitterLink = siteTwitterPage ? (
    <ExternalLink
      key="linkToTwitter"
      href={siteTwitterPage}
      className={css.icon}
      title={goToTwitter}
    >
      <IconSocialMediaTwitter />
    </ExternalLink>
  ) : null;

  const instragramLink = siteInstagramPage ? (
    <ExternalLink
      key="linkToInstagram"
      href={siteInstagramPage}
      className={css.icon}
      title={goToInsta}
    >
      <IconSocialMediaInstagram />
    </ExternalLink>
  ) : null;
  return [fbLink, twitterLink, instragramLink].filter(v => v != null);
};

const FooterComponent = props => {
  const { rootClassName, className, intl, history, isAuthenticated } = props;
  const socialMediaLinks = renderSocialMediaLinks(intl);
  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <div className={css.topBorderWrapper}>
        <div className={css.content}>
          <div className={css.someLiksMobile}>{socialMediaLinks}</div>
          <div className={css.links}>
            <div className={css.organization} id="organization">
              <NamedLink name="LandingPage" className={css.logoLink}>
                <span className={css.logo}>
                  {/* <Logo format="desktop" className={css.logosos} /> */}
                  <img src={footerlogo} alt="" className={css.footerlogo} />
                  <span className={css.footerImgSpan}>
                    <FormattedMessage id="Footer.footerImgSpan1" />
                  </span>
                  <span className={css.footerImgSpan}>
                    <FormattedMessage id="Footer.footerImgSpan2" />
                  </span>
                </span>
              </NamedLink>
            </div>

            {/* learn more column */}

            <div className={css.searchesExtra}>
              <ul className={css.list}>
                <h2 className={css.infoLinksHeading}>
                  <FormattedMessage id="Footer.headingForLearnMore" />{' '}
                </h2>
                <li className={css.listItem}>
                  <ExternalLink
                    className={css.link}
                    href="https://djob.co/a-propos/"
                    target="blank"
                  >
                    <FormattedMessage id="Footer.abutUs" />
                  </ExternalLink>
                </li>
                <li className={css.listItem}>
                  <ExternalLink
                    className={css.link}
                    href="https://djob.co/nous-joindre/"
                    target="blank"
                  >
                    <FormattedMessage id="Footer.contactUs" />
                  </ExternalLink>
                </li>

                <li className={css.listItem}>
                  <ExternalLink className={css.link} href="https://djob.co/faq/" target="blank">
                    <FormattedMessage id="Footer.faq" />
                  </ExternalLink>
                </li>
              </ul>
            </div>

            {/* <div className={css.infoLinks}>
              <ul className={css.list}>
                <h2 className={css.infoLinksHeading}>
                  {' '}
                  <FormattedMessage id="Footer.headingForCompany" />{' '}
                </h2>

                <li className={css.listItem}>
                  <ExternalLink className={css.link} href="https://djob.co/a-propos" target="blank">
                    <FormattedMessage id="Footer.toAboutPage" />
                  </ExternalLink>
                </li>
                <li className={css.listItem}>
                  <ExternalLink
                    className={css.link}
                    href="https://djob.co/nous-joindre"
                    target="blank"
                  >
                    <FormattedMessage id="Footer.toContactPage1" />
                  </ExternalLink>
                </li>
                <li className={css.listItem}>
                  <NamedLink name="underconstructionPage" className={css.link}>
                    <FormattedMessage id="Footer.toprivacyPolicy" />
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                  <NamedLink name="underconstructionPage" className={css.link}>
                    <FormattedMessage id="Footer.toblog" />
                  </NamedLink>
                </li>
              </ul>
            </div> */}

            {/* worker column */}

            <div className={css.searchesExtra}>
              <ul className={css.list}>
                <h2 className={css.infoLinksHeading}>
                  <FormattedMessage id="Footer.headingForWorkers" />{' '}
                </h2>

                <li className={css.listItem}>
                  <ExternalLink
                    className={css.link}
                    href="https://djob.co/travailleurs/"
                    target="blank"
                  >
                    <FormattedMessage id="Footer.learnAboutWorkers" />
                  </ExternalLink>
                </li>

                {!isAuthenticated && (
                  <li className={css.listItem}>
                    <NamedLink name="SignupPage" className={css.link}>
                      <FormattedMessage id="Footer.workerSignup" />
                      {/* <FormattedMessage id="Footer.getStarted" /> */}
                    </NamedLink>
                  </li>
                )}

                {/* <li className={css.listItem}>
                  <NamedLink name="underconstructionPage" className={css.link}>
                    <FormattedMessage id="Footer.termsAndConditionWorkers" />
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                  <NamedLink name="underconstructionPage" className={css.link}>
                    <FormattedMessage id="Footer.toFAQForWorkers" />
                  </NamedLink>
                </li> */}
              </ul>
            </div>

            {/* business column */}

            <div className={css.searchesExtra}>
              <ul className={css.list}>
                <h2 className={css.infoLinksHeading}>
                  <FormattedMessage id="Footer.headingForBusiness" />
                </h2>
                <li className={css.listItem}>
                  <ExternalLink
                    className={css.link}
                    href="https://djob.co/entreprises/"
                    target="blank"
                  >
                    <FormattedMessage id="Footer.learnAboutBusiness" />
                  </ExternalLink>
                </li>

                {!isAuthenticated && (
                  <li className={css.listItem}>
                    <NamedLink name="SignupAsCompanyPage" className={css.link}>
                      <FormattedMessage id="Footer.businessSignup" />
                      {/* <FormattedMessage id="Footer.getStarted" /> */}
                    </NamedLink>
                  </li>
                )}
                {/* <li className={css.listItem}>
                  <NamedLink name="underconstructionPage" className={css.link}>
                    <FormattedMessage id="Footer.termsAndConditionBusiness" />
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                  <NamedLink name="underconstructionPage" className={css.link}>
                    <FormattedMessage id="Footer.toFAQPage1" />
                  </NamedLink>
                </li> */}
              </ul>
            </div>

            {/* <div className={css.searchesExtra}>
              <ul className={css.list}>
                <h2 className={css.infoLinksHeading}>
                  <FormattedMessage id="Footer.headingForMarketplace" />{' '}
                </h2>
                <li className={css.listItem}>
                  <NamedLink name="LookingForWork" className={css.link}>
                    <FormattedMessage id="Footer.lookingForaJob" />
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                  <NamedLink name="LookingForStaff" className={css.link}>
                    <FormattedMessage id="Footer.lookingforworkers" />
                  </NamedLink>
                </li>
              </ul>
            </div> */}
          </div>

          <div className={css.copyrightmessage}>
            <p>
              <FormattedMessage
                id="Footer.copyrightMessage"
                values={{ copyrightYear: new Date().getFullYear() }}
              />
            </p>
          </div>

          <div className={css.copyrightAndTermsMobile}>
            <NamedLink name="LandingPage" className={css.organizationCopyrightMobile}>
              <FormattedMessage id="Footer.copyright" />
            </NamedLink>
            <div className={css.tosAndPrivacyMobile}>
              <NamedLink name="PrivacyPolicyPage" className={css.privacy}>
                <FormattedMessage id="Footer.privacy" />
              </NamedLink>
              <NamedLink name="TermsOfServicePage" className={css.terms}>
                <FormattedMessage id="Footer.terms" />
              </NamedLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

FooterComponent.defaultProps = {
  rootClassName: null,
  className: null,
};

FooterComponent.propTypes = {
  rootClassName: string,
  className: string,
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { isAuthenticated } = state.Auth;

  return { isAuthenticated };
};
const Footer = compose(
  withRouter,
  connect(mapStateToProps)
)(injectIntl(FooterComponent));
export default Footer;
